import { render, staticRenderFns } from "./CommonDeliveryNoteStatusSelect.vue?vue&type=template&id=b40ae4a6&lang=pug&"
import script from "./CommonDeliveryNoteStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./CommonDeliveryNoteStatusSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDeliveryNoteStatusSelect.vue?vue&type=style&index=0&id=b40ae4a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports